import React from 'react';

interface ComoFuncionaSectionProps {
  scrollToSection: (id: string) => void;
}

export default function ComoFuncionaSection({ scrollToSection }: ComoFuncionaSectionProps) {
  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-4">
            Processo Simples e Transparente
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-serif">
            Como funciona? São 3 passos!
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Sem burocracia. Sem complicação. Você não precisa entender de leis — nós cuidamos de tudo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="relative">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border-2 border-teal-200 hover:shadow-xl transition-all duration-300 h-full">
              <div className="absolute -top-5 -left-5 w-14 h-14 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
                1
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6 mt-4">
                <i className="ri-send-plane-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Você Envia Seus Dados
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Preencha o formulário rápido ou mande mensagem no WhatsApp. Precisamos apenas de informações básicas sobre o que aconteceu.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Nome e contato</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Tipo de problema</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Dados do voo (se tiver)</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border-2 border-teal-200 hover:shadow-xl transition-all duration-300 h-full">
              <div className="absolute -top-5 -left-5 w-14 h-14 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
                2
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6 mt-4">
                <i className="ri-search-eye-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Análise Gratuita do Caso
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nossa equipe analisa seu caso com base nas normas da ANAC e no Código de Defesa do Consumidor. Você recebe a resposta em até 24 horas.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>100% gratuito</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Sem compromisso</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Resposta clara e direta</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border-2 border-teal-200 hover:shadow-xl transition-all duration-300 h-full">
              <div className="absolute -top-5 -left-5 w-14 h-14 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
                3
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6 mt-4">
                <i className="ri-money-dollar-circle-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Você Recebe Sua Indenização
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Se o caso for viável, entramos com a ação judicial. Você não paga nada adiantado. Só cobramos honorários se você ganhar.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Sem custos iniciais</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Só paga se ganhar</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Acompanhamento transparente</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Você não precisa ir ao Fórum
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Cuidamos de toda a parte jurídica. Você só precisa fornecer as informações e documentos — o resto é com a gente. Atendemos clientes em todo o Brasil de forma 100% online.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('contato')}
              className="inline-flex items-center gap-3 bg-teal-500 hover:bg-teal-600 text-white px-10 py-5 rounded-full text-lg font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-text-line text-xl"></i>
              Começar Minha Análise Gratuita
            </button>
            <a
              href="https://wa.me/5528998813826?text=Quero%20saber%20mais%20sobre%20como%20funciona%20o%20processo%20de%20indeniza%C3%A7%C3%A3o%20por%20problema%20com%20voo."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-10 py-5 rounded-full text-lg font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Tirar Dúvidas no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
